var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticStyle: { "margin-top": "15px" },
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "copyForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.copyForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "修改授权信息：", prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    model: {
                      value: _vm.copyForm.companyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.copyForm,
                          "companyName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "copyForm.companyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传授权图片：", prop: "region" } },
                [
                  _c("div", { staticClass: "authorized" }, [
                    _vm.copyForm.companyImage
                      ? _c("div", { staticClass: "uploadPictrue" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.copyForm.companyImage,
                                expression: "copyForm.companyImage",
                              },
                            ],
                          }),
                          _c("i", {
                            staticClass: "el-icon-error btndel",
                            on: { click: _vm.handleRemove },
                          }),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "upload",
                            on: {
                              click: function ($event) {
                                return _vm.modalPicTap()
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "iconfont" }, [
                              _vm._v("+"),
                            ]),
                          ]
                        ),
                  ]),
                  _c("div", { staticClass: "prompt" }, [
                    _vm._v("建议尺寸：宽290px*高100px"),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["platform:copyright:update:company:info"],
                      expression: "['platform:copyright:update:company:info']",
                    },
                  ],
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveCopyRight("copyForm")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isTemplate
        ? _c(
            "el-dialog",
            {
              staticClass: "mapBox",
              staticStyle: { padding: "0" },
              attrs: {
                visible: _vm.isTemplate,
                "close-on-click-modal": false,
                "before-close": _vm.handleClose,
                width: "440px",
                title: _vm.title,
                "close-on-click-modal": "",
                "custom-class": "dialog-scustom",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isTemplate = $event
                },
              },
              model: {
                value: _vm.isTemplate,
                callback: function ($$v) {
                  _vm.isTemplate = $$v
                },
                expression: "isTemplate",
              },
            },
            [
              _c("iframe", {
                staticStyle: { width: "400px", height: "600px" },
                attrs: { src: _vm.iframeUrl, frameborder: "0" },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }